import { call, put, select } from 'redux-saga/effects';
import * as actions from './actions';
import axios from 'axios';
import { waitFor } from 'store/helpers/sagaHelpers';
import get from 'lodash.get';
import { isIFrame } from 'store/helpers/helperFunctions';

const apiRoot = `${window._env_?.REACT_APP_SCHEMA_API_PATH}`;

const getSchemaApiRoot = (tenantId, businessContextId) =>
  `${apiRoot}tenants/${tenantId}/context/${businessContextId}`;

export const updateSettingsMetaDataAsync = (
  tenantId,
  businessContextId,
  settingsMetaData
) => {
  let axiosRequest = {
    method: 'put',
    url: `${window._env_?.REACT_APP_API_PATH}tenants/${tenantId}/context/${businessContextId}/settings/${settingsMetaData.id}`,
    data: settingsMetaData
  };

  return axios(axiosRequest)
    .then(response => {
      return response.data;
    })
    .catch(err => {
      throw err;
    });
};

export const getSettingsMetaDataAsync = (tenantId, businessContextId) => {
  return axios
    .get(
      `${window._env_?.REACT_APP_API_PATH}tenants/${tenantId}/context/${businessContextId}/settings`
    )
    .then(response => {
      if (
        !response.data.integratingProducts ||
        response.data.integratingProducts.length === 0
      ) {
        response.data.integratingProducts = [''];
      }
      return get(response, 'data', {});
    })
    .catch(err => {
      throw err;
    });
};

export const getAvailableLanguagesAsync = (tenantId, businessContextId) => {
  return axios
    .get(
      `${getSchemaApiRoot(
        tenantId,
        businessContextId
      )}/localized-schema/configuration/supported-languages`
    )
    .then(response => response.data)
    .catch(err => {
      throw err;
    });
};

// selectors
const availableLanguagesData = store => store.settings.availableLanguages;
const currentTenantId = store => store.user.selectedTenant.tenantId;
const currentBusinessContextId = store =>
  store.user.selectedBusinessContext.businessContextId;

export function* waitForGetAllMetaData() {
  yield waitFor(
    actions.getAllMetaData,
    actions.GETTING_ALL_META_DATA_SUCCEEDED,
    actions.GETTING_ALL_META_DATA_FAILED
  );
}

export function* waitForGetAllLanguages() {
  yield waitFor(
    actions.getAvailableLanguages,
    actions.GET_AVAILABLE_LANGUAGES_SUCCEEDED,
    actions.GET_AVAILABLE_LANGUAGES_FAILED
  );
}

export function* getAllMetaData(action) {
  try {
    yield put(actions.gettingAllMetaData());
    let availableLanguages = yield select(availableLanguagesData);
    if (availableLanguages?.length === 0) {
      yield call(waitForGetAllLanguages);
      availableLanguages = yield select(availableLanguagesData);
    }
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let settingsData;
    settingsData = yield call(
      getSettingsMetaDataAsync,
      tenantId,
      businessContextId
    );
    yield put(actions.gettingAllMetaDataSucceeded(settingsData));
    if (isIFrame()) {
      yield put(actions.updateLanguagePreference(availableLanguages.filter(language => language.languageCode === window.localStorage.getItem('GCM-languageCode'))[0]))
    } else {
      yield put(actions.updateLanguagePreference(availableLanguages.filter(language => language.languageCode === settingsData?.languageCode)[0]))
    }
  } catch (ex) {
    yield put(actions.gettingAllMetaDataFailed(ex));
  }
}

export function* updateSettingsMetaDataFromCurrent(action) {
  try {
    yield put(actions.updatingSettingsMetaData());
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let settingsData;

    settingsData = yield call(
      updateSettingsMetaDataAsync,
      tenantId,
      businessContextId,
      action.payload
    );

    yield put(actions.updatingSettingsMetaDataSucceeded(settingsData));
    yield put(actions.saveSettingsSucceeded());
  } catch (ex) {
    yield put(actions.updatingSettingsMetaDataFailed(ex));
  }
}

export function* getAvailableLanguagesIfNeeded(action) {
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let availableLanguages = yield call(
      getAvailableLanguagesAsync,
      tenantId,
      businessContextId
    );

    yield put(actions.getAvailableLanguagesSucceeded(availableLanguages));
  } catch (ex) {
    yield put(actions.getAvailableLanguagesFailed(ex));
  }
}
